module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("THE CANOPY")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe.page-template+xml"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "page14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1a#aa3",
      "id": "bb3"
    }
  }, [_vm._v("1 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003")])]), _vm._v(" "), _c('p', {
    staticClass: "ct1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1a#aa3"
    }
  }, [_vm._v("9:20 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": ".",
      "id": "p0014-d6e26",
      "src": "images/9780849943454_INT_0014_002.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0014-03-1"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("D")]), _vm._v("r. Michael Kenway removed the tongue depressor from his small patient’s mouth, then patted the boy’s cheek with two fingertips. "), _c('i', [_vm._v("“Bien.”")]), _vm._v(" Yielding to the deficiencies of his Spanish, he gave the boy a wide smile, hoping it would say what he could not. "), _c('i', [_vm._v("“Es muy bien.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-04-4"
    }
  }, [_vm._v("The little boy’s eyes darted to his mother’s face, then he scrambled into her arms. Michael picked up the child’s chart and scribbled a note to himself, then glanced at his nurse, Fortuna.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-05-6"
    }
  }, [_vm._v("“Please tell the mother that she must continue giving him the antibiotics until they are all gone. His throat is better, but it’s quite important that her son finish all the medication. If he gets sick again, she must bring him back to the hospital immediately.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-06-8"
    }
  }, [_vm._v("Fortuna nodded, then turned to address the mother. While she translated his instructions in a geyser of Spanish, Michael flipped the page and studied the boy’s chart.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-07-10"
    }
  }, [_vm._v("The folder contained far too little information on the lad, and the available data was incredibly unhelpful. Four-year-old Rudolfo Lopez had been born in the village of Puerto Miguel, his mother had received no prenatal care, and the child had received no vaccinations—at least none were recorded. Michael suspected the boy may have received immunizations for measles or DPT when missionary doctors passed through the village, but since no one kept records, how could he be sure?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-07-11"
    }
  }, [_vm._v("Aside from the raging case of strep throat that had compelled Rudolfo’s mother to bring her son to the hospital last week, the boy seemed in good health. Surprising, really, that the mother brought him in at all—for anyone who traveled by canoe, Puerto Miguel lay a good five hours away from the hospital and the journey would be exhausting. Furthermore, since prescription drugs were available in Peru for anyone who could pay for them, most people self-medicated first and talked to a physician only if their medicines of choice had no effect.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("He lifted his hand, interrupting Fortuna. “Does Puerto Miguel have a chemist?”")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-02-2"
    }
  }, [_vm._v("She frowned.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-03-4"
    }
  }, [_vm._v("“You know, a place to buy medicine—"), _c('i', [_vm._v("una farmacia")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-04-6"
    }
  }, [_vm._v("Her frown deepened. “Why, Doctor, do you ask about Puerto Miguel?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-05-8"
    }
  }, [_vm._v("“Doesn’t this woman live in Puerto Miguel?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-06-10"
    }
  }, [_vm._v("Fortuna looked at him as if he’d just suggested the lady lived on the moon. “No, Doctor! She lives here in Iquitos, by the Belen Market.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-P-1"
    }
  }, [_vm._v("“Ah. Has she lived here long?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-07-12"
    }
  }, [_vm._v("Fortuna put the question to the patient, then returned the answer. “Two years.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-08-14"
    }
  }, [_vm._v("“Good.” Grateful to have one mystery solved, Michael jotted this information on the chart.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-09-16"
    }
  }, [_vm._v("The mother, a dark-haired woman whose face had been prematurely etched with lines of weariness, thanked him as she stood and settled the child onto her hip. "), _c('i', [_vm._v("“Muchas gracias, el doctor.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-10-18"
    }
  }, [_vm._v("Michael reached out to ruffle the boy’s hair. "), _c('i', [_vm._v("“De nada, Señora Lopez. Adiós, Rudolfo.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-11-20"
    }
  }, [_vm._v("Fortuna led them out, then lingered outside the doorway. “Do I need to clean the room this time, "), _c('i', [_vm._v("el doctor?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-12-22"
    }
  }, [_c('i', [_vm._v("“Si.”")]), _vm._v(" Michael gestured toward the can of spray disinfectant on the counter. “Every surface and the mattress, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-13-24"
    }
  }, [_vm._v("Leaving his nurse to clean up, he shook his head as he left the exam room. Peruvian medicine was not backward, but supplies were hard to obtain in this city. Hemmed in by the forest and accessible only by river or air, Iquitos was home to half a million people, most of whom lived in poverty. In addition to serving the residents of Iquitos, Regional Hospital also provided medical care to untold numbers of people who still preferred to live in the vast jungle along the Amazon.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-14-26"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("When he first arrived, he had instructed Fortuna to clean the room after every patient, but soon he realized that New World standards of cleanliness were inappropriate in the jungle. Spray disinfectant was")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v(" difficult to obtain, and when it was not available, Fortuna had to scrub the room with soap and standing water from a pail—not exactly a sterile solution.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-02-2"
    }
  }, [_vm._v("Now she disinfected the room only after treating infectious patients. Michael’s British colleagues would be horrified by his revised office procedures, but three years in the jungle had taught him to reorder his priorities.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-03-4"
    }
  }, [_vm._v("He was moving toward the waiting area to summon his next patient when an orderly rounded the corner. “Dr. Kenway! "), _c('i', [_vm._v("¡Prisa! ¡Emergencia!”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-P-1"
    }
  }, [_vm._v("Leaving his patients in their chairs, Michael broke into a jog and followed the orderly through the serpentine hallways that led to the casualty ward. He saw no patients in the narrow receiving area, but the double doors beyond stood open to a brick-walled courtyard. There, under the blinding tropical sun, two men were carrying an inert body on a stretcher.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-04-6"
    }
  }, [_vm._v("Michael pulled a pair of latex gloves from the pocket of his lab coat as he hurried forward. The patient wore no clothing apart from a string of twine around his waist, but someone else might have stripped him as they tried to assess his condition. The patient’s problem, however, was obvious—a ten-centimeter wound in his lower abdomen had coated half of the man’s groin with blood.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-05-8"
    }
  }, [_vm._v("Signaling the stretcher-bearers to halt, Michael lifted the man’s wrist even as he scanned the body. Judging by the bowl haircut and the facial markings, the fellow appeared to be Indian, but Michael had never seen a native so covered with tattoos. The patient was emaciated, suffering chills and dehydrated, for despite the intense heat he was not perspiring.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-06-10"
    }
  }, [_vm._v("“Lucky bloke,” Michael murmured, studying the injury. If whatever had penetrated the abdomen had struck the abdominal aorta, this fellow wouldn’t have made it out of the jungle.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-07-12"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("He bent to check the native’s respiration. As he pressed his stethoscope to the man’s chest, he noted there were no visible indications of chest trauma or signs of bruising. The man’s heart, however, was racing, probably the result of the body’s demand for oxygen because of dehy")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("dration or a septic state resulting from his injury. Michael realized he might be looking at a bowel perforation . . . always a critical situation.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-02-1"
    }
  }, [_vm._v("The only other obvious indication of injury was a bloody right hand, but after a quick examination Michael realized the skin had not been lacerated—the man had used his hand to apply pressure to the injury.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-02-2"
    }
  }, [_vm._v("Clicking his tongue against his teeth, Michael pointed the stretcherbearers inside. This patient, whoever he was, was probably more than half dead already, but perhaps the infection could be halted. Indigenous individuals who had not been exposed to antibiotics often responded with amazing swiftness if the proper drugs were administered in time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-P-1"
    }
  }, [_vm._v("Following his casualty patient, Michael called for help, then hurried to the exam room where the stretcher-bearers had clumsily transferred their burden to a gurney. Michael thanked them, then bit the inside of his lip as he bent over the Indian. The man was unconscious, which was probably a mercy, but he’d have to go into surgery almost immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-03-4"
    }
  }, [_vm._v("A pair of orderlies strode into the room. Michael was about to issue instructions for IV fluids when one of them threw up his hands and stepped away from the table.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-04-6"
    }
  }, [_vm._v("“What’s wrong?” When the orderly didn’t answer, Michael looked at the second man, a fellow he had worked with on several occasions. “Rico, what’s bothering your friend?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-05-8"
    }
  }, [_vm._v("A shadow of annoyance crossed Rico’s face as he questioned his coworker. In a torrent of Spanish they argued across the exam table until Michael interrupted. “Hold it!” He held up his gloved hands. “Stop! In English, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-06-10"
    }
  }, [_vm._v("Rico cast a look of derision at his companion. “Hector will not touch this man. I told him he is an ignorant fool, but still he refuses.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-P-2"
    }
  }, [_vm._v("Michael glanced at the patient on the table. “Why not? Does he know this fellow?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-07-12"
    }
  }, [_vm._v("Rico shook his head. “He knows nothing about him. But Hector is Yagua, and superstitious. He is only one generation removed from the jungle, and he will not let go of the old ideas.”")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("With no time for further questions, Michael jerked his thumb over his shoulder. “If Hector won’t work, get him out of here and find someone who will. But we haven’t time to argue the point.”")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-02-2"
    }
  }, [_vm._v("Hector left immediately, with Rico hounding his heels. Snorting at the inefficiency of jungle medicine, Michael pulled an IV bag from a cart and glanced up at the two good Samaritans who had delivered the patient. They had remained in the room and were now leaning against the wall in the relaxed attitude of men who had finished their work and were happy to watch someone else hustle for a while.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-03-4"
    }
  }, [_vm._v("“Do either of you speak English? "), _c('i', [_vm._v("¿Habla inglés?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-04-6"
    }
  }, [_vm._v("The first fellow shook his head, but the second, a burly man in shirtsleeves, nodded. “I am Paco. I speak English.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-05-8"
    }
  }, [_vm._v("Michael forced a smile. “Good. Where did you find this fellow?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-06-10"
    }
  }, [_vm._v("The man scratched his head, then pointed toward the east-facing window. “Some of the river people brought him to us this morning. They say he came out of the jungle and started shouting in a language they had never heard.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-07-12"
    }
  }, [_vm._v("Michael frowned as he tapped the patient’s inner arm. He could feel the heat of fever even through his gloves. Due to dehydration, the veins had totally collapsed. “He came out of the jungle? Where?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-08-14"
    }
  }, [_vm._v("Paco shook his head. “I don’t know. The people who brought him in were eager to be rid of him. They kept saying something about a "), _c('i', [_vm._v("maldición.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-09-16"
    }
  }, [_vm._v("“A what?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-10-18"
    }
  }, [_vm._v("“A curse, "), _c('i', [_vm._v("el doctor.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-11-20"
    }
  }, [_vm._v("Michael groaned inwardly as he splashed the patient’s neck with Betadine in preparation for a right IJ triple lumen. Though Peru was a modern nation, primitive practices persisted in many parts of the country. “Curses do not cause wounds like this, Paco. A weapon injured this man.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-12-22"
    }
  }, [_vm._v("“I do not think they meant a curse made him sick—they said he "), _c('i', [_vm._v("was")]), _vm._v(" a "), _c('i', [_vm._v("maldición.”")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-13-24"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("With an ease born of practice, Michael inserted the large-bore catheter into the patient’s jugular vein. “I think it’s rather apparent this")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v(" fellow might have been a victim of bad luck, but I doubt he was the cause of it.” As he reached for a syringe, Michael tipped his chin toward the wound. “Do you have any idea what caused this?”")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-02-2"
    }
  }, [_vm._v("“No, Doctor. No idea.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-03-4"
    }
  }, [_vm._v("Michael filled the syringe with five ccs of heparin, then slid the needle into each of the three ports of the triple lumen to test for blood return. When he was certain there were no clogs, he injected the drug, then reached for a curved needle on the cart behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-04-6"
    }
  }, [_vm._v("The first tug of silk through flesh must have undone Paco’s friend, for by the time Michael tied off the sutures securing the catheter, both men had inched toward the doorway. Their faces, which had been open and curious a moment before, now gleamed pale with perspiration. Experience told Michael that if they did not leave, soon "), _c('i', [_vm._v("they")]), _vm._v(" might be lying on a gurney.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-05-8"
    }
  }, [_c('i', [_vm._v("“Gracias, amigos,")]), _vm._v(" for bringing this bloke in. You may have saved his life.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-06-10"
    }
  }, [_vm._v("Both men nodded in mute acknowledgment, then slipped out of the room. A moment later, Rico returned and took his place beside the gurney.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-07-12"
    }
  }, [_vm._v("“What do you need, "), _c('i', [_vm._v("el doctor?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-08-14"
    }
  }, [_vm._v("Michael inserted an IV line into the first port, then stepped back to allow Rico room to work. “Cefoxitin, two-gm slow IV push. At least two liters of fluids. As soon as we get some fluids in him, call for an operating room; this patient is headed to surgery.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-09-16"
    }
  }, [_vm._v("As Rico worked at the native’s head, Michael tenderly probed the tissue around the abdominal wound. The skin was swollen and warm to the touch. After injecting a bit of local anesthesia into the matted tissue, Michael debrided the area with a scalpel and noted that the peritoneum had been violated. Only the pressure of the man’s hand had kept his intestines from spilling through the opening.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-10-18"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("As Michael probed the flesh, he noticed fecal staining on the edges of the wound—obvious evidence of a bowel perforation. Small wonder the patient had passed out. The pain of the abdominal wound, coupled with severe dehydration and septic shock resulting")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v(" from bacteria-laden fecal material . . . amazing that he had made it out of the jungle at all.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-02-2"
    }
  }, [_vm._v("Undoubtedly, massive peritonitis caused by the infection in the abdomen had already led to bacteremia, the result of bacteria invading the bloodstream, and possibly septicemia, in which the entire body began to experience the effects of poison. Unless Michael could infuse his patient with fluids, repair the colon, and administer effective antibiotics, septic shock would be followed by multisystem organ failure, beginning with the kidneys.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-03-4"
    }
  }, [_vm._v("Looking up, Rico caught Michael’s eye. “What do you think, "), _c('i', [_vm._v("el doctor?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-04-6"
    }
  }, [_vm._v("Michael dropped a sterile dressing over the wound. “We’re probably looking at massive peritonitis,” he answered, “bacteremia, and septicemia. Septic shock, probable kidney failure. We’ll be facing multisystem organ failure within a few hours . . . unless the Almighty sends us a bloomin’ miracle.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-05-8"
    }
  }, [_vm._v("He snapped off his gloves. “I’m going to scrub up, Rico. Take this man to whatever operating room is available and wake the anesthetist from his midmorning siesta. We’ve no time to waste.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb8e940a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter6.vue
// module id = 81
// module chunks = 0